import React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

const tagStyles = cva('mr-2 mb-1 px-2 py-[0] pt-[1px] me-2 text-xs font-bold justify-self-start rounded inline-block', {
  variants: {
    variant: {
      gradient:
        'text-white bg-gradient-to-r from-[#08B3BD] via-20% to-[#7AD817] to-90% cursor-pointer hover:opacity-85',
      hollow:
        'text-black border hover:border-[#7AD817] border-gray-600 text-gray-600 hover:text-white hover:bg-[#7AD817] cursor-pointer',
      free: 'text-white bg-purple-500 hover:opacity-100 cursor-default',
      'free-hollow': 'text-purple-500 border border-purple-500 hover:text-white hover:bg-purple-500 cursor-pointer',
    },
  },
  defaultVariants: {
    variant: 'gradient',
  },
});

export interface TagProps extends React.HTMLAttributes<HTMLSpanElement>, VariantProps<typeof tagStyles> {
  label: string;
}

const Tag = ({ label, variant, className, onClick, ...props }: TagProps) => {
  return (
    <span className={tagStyles({ variant, className })} onClick={onClick} {...props}>
      {label}
    </span>
  );
};

export default Tag;
